import { useParams } from 'react-router';
import { useApi, PageContext } from '@axiom/ui';
import { isAhqUser } from '@axiom/utils';
import { useEffect, useContext } from 'react';

import { CandidateApi } from '../api/candidate-api';
import { UserApi } from '../api/user-api';
import { CandidateUtil } from '../utils/candidate-util';

export const useDocumentTitle = (appendTitle: string) => {
  const { setTitle } = useContext(PageContext);
  const [{ data: user }] = useApi(UserApi.readUser());
  const { candidateId: urlCandidateId } = useParams();
  const candidateId = CandidateUtil.reconcileUserCandidateId(
    user,
    urlCandidateId
  );

  if (!candidateId) {
    throw new Error('Talent id is missing');
  }

  const [{ data: candidate }] = useApi(CandidateApi.readCandidate(candidateId));

  const title = isAhqUser(user)
    ? `${candidate.calculatedDisplayName} - ${appendTitle}`
    : `AxiomLaw - ${appendTitle}`;

  useEffect(() => {
    setTitle(title);
  }, [setTitle, title]);

  return title;
};
